import React, { useState } from "react";
import uploadImage from "@/public/images/uploadImage.svg";
import Image from "next/image";
import CustomInput from "@/components/shared/CustomInput";
import CustomSelect from "@/components/shared/CustomSelect";
import uploadImage2 from "@/public/images/uploadImage2.svg";
import { ErrorMessage, Field, FormikProps } from "formik";
import { X } from "lucide-react";
import { handleKeyDownNumber } from "@/lib/utils";
const index = ({ formikProps }: { formikProps: FormikProps<any> }) => {
  const [SelectedImage1, setImage1] = useState({ file: "", url: "" });
  const [SelectedImage2, setImage2] = useState({ file: "", url: "" });
  const [Images, setImages] = useState<
    { file: File | undefined; url: string | undefined | any }[]
  >([{ file: undefined, url: undefined }]);
  return (
    <div className=" flex flex-col gap-5">
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-5 items-center">
        <CustomInput
          type="text"
          name="fullName"
          placeholder="اسمك بالكامل رباعي"
          label="اسمك بالكامل رباعي"
          FormikProps={formikProps}
          required={true}
        />
        <CustomSelect
          name="gender"
          placeholder="الجنس"
          label="الجنس"
          data={[
            { id: "ذكر", name: "ذكر" },
            { id: "انثي", name: "انثي" },
          ]}
          FormikProps={formikProps}
        />
        <CustomInput
          type="text"
          name="fatherJob"
          placeholder="وظيفه ولي الامر"
          label="وظيفه ولي الامر"
          FormikProps={formikProps}
        />
        <CustomInput
          type="text"
          name="fatherPhone"
          placeholder="رقم هاتف ولي الامر"
          label="رقم هاتف ولي الامر"
          onKeyDown={handleKeyDownNumber}
          FormikProps={formikProps}
          // maxLength={11}
        />
      </div>
      <CustomInput
        type="number"
        name="nationalId"
        placeholder="رقمك القومي"
        label="رقمك القومي"
        FormikProps={formikProps}
        required={true}
      />
      {/* <div
        className={`bg-[#474A4D] rounded-[10px] p-5 flex flex-col  justify-between gap-5 ${
          (formikProps.errors.nationalFront ||
            formikProps.errors.nationalBack) &&
          "border border-red-500"
        }`}
      >
        <div>
          <p className=" text-18 text-white fonr-[600]">
            ارافق صوره للبطاقه وش وظهر
          </p>
          <p className=" text-16 text-textColor">
            ارفع 2 صوره وش وظهر للبطاقه بشكل منفرد
          </p>
          <div className=" mt-5 flex flex-wrap gap-5">
            {Images[0].url !== undefined &&
              Images.map((image, index) => (
                <Image
                  src={image.url}
                  alt="uploadImage2"
                  key={index}
                  width={150}
                  height={150}
                />
              ))}
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-5">
          <div>
            <p className=" text-16 text-textColor mb-5">صوره وش البطاقه</p>
            {SelectedImage1.url == "" ? (
              <div className=" relative">
                <Field
                  type="file"
                  name="nationalFront"
                  accept=".png, .jpg, .jpeg"
                  className=" w-full h-full absolute inset-0 bg-red-500 cursor-pointer opacity-0 "
                  value={undefined}
                  onChange={(e: any) => {
                    setImage1({
                      file: e.target.files[0],
                      url: URL.createObjectURL(e.target.files[0]),
                    });

                    formikProps.setFieldValue(
                      "nationalFront",
                      e.target.files[0]
                    );
                  }}
                />
                <Image src={uploadImage2} alt="uploadImage2" />
                <ErrorMessage
                  name="nationalFront"
                  component="div"
                  className="text-[#F75555]"
                />
              </div>
            ) : (
              <div className=" flex flex-col items-center justify-center gap-5">
                <Image
                  src={SelectedImage1.url}
                  alt="uploadImage2"
                  width={150}
                  height={150}
                  className="w-[150px] h-[150px] object-cover"
                />
                <X
                  className=" text-red-500 cursor-pointer"
                  onClick={() => {
                    setImage1({ file: "", url: "" });
                    formikProps.setFieldValue("nationalFront", null);
                  }}
                />
                <ErrorMessage
                  name="nationalFront"
                  component="div"
                  className="text-[#F75555]"
                />
              </div>
            )}
          </div>
          <div>
            <p className=" text-16 text-textColor mb-5">صوره ظهر البطاقه</p>
            {SelectedImage2.url == "" ? (
              <div className=" relative">
                <Field
                  type="file"
                  name="nationalBack"
                  accept=".png, .jpg, .jpeg"
                  className=" w-full h-full absolute inset-0 bg-red-500 cursor-pointer opacity-0 "
                  value={undefined}
                  onChange={(e: any) => {
                    setImage2({
                      file: e.target.files[0],
                      url: URL.createObjectURL(e.target.files[0]),
                    });

                    formikProps.setFieldValue(
                      "nationalBack",
                      e.target.files[0]
                    );
                  }}
                />
                <Image src={uploadImage2} alt="uploadImage2" />
                <ErrorMessage
                  name="nationalBack"
                  component="div"
                  className="text-[#F75555]"
                />
              </div>
            ) : (
              <div className=" flex flex-col items-center justify-center gap-5">
                <Image
                  src={SelectedImage2.url}
                  alt="uploadImage2"
                  width={150}
                  height={150}
                  className="w-[150px] h-[150px] object-cover"
                />
                <X
                  className=" text-red-500 cursor-pointer"
                  onClick={() => {
                    setImage2({ file: "", url: "" });
                    formikProps.setFieldValue("nationalBack", null);
                  }}
                />
                <ErrorMessage
                  name="nationalBack"
                  component="div"
                  className="text-[#F75555]"
                />
              </div>
            )}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default index;
